export const environment = {
  production: false,
  apiUrl: '/api',
  pvfTopUrl: 'https://dev.visualstudio.panasonic.com/toppage',
  enableTestPage: true,
  language: 'en' as 'ja' | 'en',
  adobe: {
    express: {
      clientId: 'a831ea1c837a44db89230896eb5729ba',
      name: '',
    },
  },
  cognito: {
    authority:
      'https://cognito-idp.ap-northeast-1.amazonaws.com/ap-northeast-1_H4cJcfa4I',
    clientId: 'n5i9qm7gfoirqgkv1dngsc7q1',
    logoutEndpoint:
      'https://ap-northeast-1h4cjcfa4i.auth.ap-northeast-1.amazoncognito.com/logout',
    scope: 'openid',
  },
  logging: {
    sendLogsUrl: 'https://iw7drj84f9.execute-api.ap-northeast-1.amazonaws.com/dev_send_logs',
  },
};
